import Vue from 'vue'
import VueRouter from 'vue-router'

// Login
import Login from '../pages/Login/Login.vue'
import Register from '../pages/Register/Register.vue'



//ecom tracking 
import POTrackingForm from '@/pages/POTrackingForm/Form.vue'
import viewPOTrackingData from '@/pages/ViewPOTrackingData/Table.vue'
import connectDocusign from '@/pages/ConnectDocusign/ConnectDocusign.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name:'Register',
    component: Register

  },
  // ecom tracking 
  {
    path:'/onboarding',
    name: 'L&F Onboarding',
    component: POTrackingForm
  },
  {
    path:'/view-data',
    name: 'View Entries',
    component: viewPOTrackingData
  },  
  {
    path:'/connect-docusign',
    name: 'Connected Docusign Accounts',
    component: connectDocusign
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
